


function getUserFromLocalStorage() {
  try {
    const user = localStorage.getItem('user');
    if (user && user !== 'undefined' && user !== 'null') {
      return JSON.parse(user);
    }
    return null;
  }
  catch (e) {
    console.log(e);
    delete localStorage.user;
    window.location.replace('/login')
  }
}


export default {
  getUserFromLocalStorage
};
